/**
 * HeatingCostChart — Bar chart visualization of heating costs
 */

import { BarChart } from '@mantine/charts';
import { Paper, Text } from '@mantine/core';
import type { HeatingCostComparison } from '../types/heatingCost.types';
import { FUEL_CATEGORY_COLORS } from '../constants/fuelDefaults';

interface HeatingCostChartProps {
  comparison: HeatingCostComparison;
}

export function HeatingCostChart({ comparison }: HeatingCostChartProps) {
  const data = comparison.results.map(r => ({
    name: `${r.variant.label} (${r.variant.boilerType})`,
    'Koszt roczny': Math.round(r.annualCostGross),
    color: FUEL_CATEGORY_COLORS[r.variant.category] ?? '#999',
  }));

  return (
    <Paper p="md" withBorder radius="md">
      <Text size="sm" fw={500} mb="md">Porównanie kosztów ogrzewania (zł/rok)</Text>
      <BarChart
        h={Math.max(300, comparison.results.length * 32)}
        data={data}
        dataKey="name"
        series={[{ name: 'Koszt roczny', color: 'blue.6' }]}
        orientation="vertical"
        gridAxis="x"
        tickLine="x"
        barProps={{ radius: [0, 4, 4, 0] }}
        valueFormatter={(value) => `${value.toLocaleString('pl-PL')} zł`}
      />
    </Paper>
  );
}
